import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyTheme, resolveTheme } from "@/hooks/useTheme";

/* Applies the resolved theme on public pages; admin pages always stay light. */
export default function ThemeManager() {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");

    useEffect(() => {
        if (isAdmin) {
            applyTheme("light");
            return undefined;
        }
        const sync = () => applyTheme(resolveTheme());
        sync();
        const mq = window.matchMedia("(prefers-color-scheme: dark)");
        mq.addEventListener("change", sync);
        return () => mq.removeEventListener("change", sync);
    }, [isAdmin]);

    return null;
}
